<template>
  <div>
    <div id="custom_card" class="card sticky">
      <div class="grid justify-content-between">
        <div class="col-12 md:col-9">
          <div
            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
          >
            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
              {{ $t("dash") }}
            </p>
          </div>
        </div>
        <div class="col-12 md:col-3">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12">
              <span class="p-float-label">
                <Dropdown
                  id="Clients"
                  v-model="selectedproduct"
                  :options="products"
                  optionLabel="name"
                  v-on:change="getsupersetID()"
                ></Dropdown>
                <label for="Clients">{{ $t("select_client") }}</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <superset_dashboard
      superset_id="d941274c-22b7-4df0-80a1-21176f8cd65c"
    ></superset_dashboard> -->
    <superset_dashboard
      :superset_id="ClientID"
      :key="ClientID + '-' + count"
    ></superset_dashboard>
  </div>
</template>
<script>
import superset_dashboard from "../components/superset_dashboard";
import apis from "@/apis";
export default {
  data() {
    return {
      products: [],
      selectedproduct: "",
      ClientID: "",
      count: 0,
    };
  },
  productService: null,
  themeChangeListener: null,
  async mounted() {},
  async created() {
    this.get_list();
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    currentLocale() {
      this.get_list(this.currentLocale);
    },
  },
  methods: {
    getsupersetID() {
      this.ClientID = this.selectedproduct?.code;
      this.count++;
    },
    get_list() {
      this.products = [];
      var promise = apis.getClientList({});
      promise.then((response) => {
        //new
        const temp = response.data.data;
        if (temp.length > 0) {
          const locale = this.$i18n.locale;
          const selectedId = this.selectedproduct?._id;
          this.products = temp.map((item) => ({
            name: locale === "en" ? item.name : item.name_mr,
            code: item.superset_id,
            _id: item._id,
          }));
          const matchedProduct = this.products.find(
            (p) => p._id === selectedId
          );
          if (matchedProduct) {
            this.selectedproduct = matchedProduct;
            this.ClientID = matchedProduct.code;
          } else {
            this.selectedproduct = this.products[0];
            this.ClientID = this.products[0].code;
          }
          this.count++;
        }
        //old
        // var temp = response.data.data;
        // if (temp.length>0)
        // {
        //   var flag=0;
        //   for (let i = 0; i < temp.length; i++)
        //   {
        //     this.products.push({
        //       name: this.$i18n.locale === "en" ? temp[i].name : temp[i].name_mr,
        //       code: temp[i].superset_id,
        //       _id:temp[i]._id
        //     });
        //     if (this.selectedproduct && this.selectedproduct._id && this.selectedproduct._id == this.products[i]._id)
        //     {
        //        this.selectedproduct = this.products[i];
        //        this.ClientID = this.selectedproduct.code;
        //        flag++;
        //     }
        //   }
        //   if (flag==0)
        //   {
        //         this.selectedproduct = this.products[0];
        //         this.ClientID = this.products[0].superset_id;
        //   }
        //   this.count++;
        // }
      });
    },
  },
  components: {
    superset_dashboard,
  },
};
</script>
<style></style>
<style scoped>
#custom_card {
  border-top: 3px solid #3f51b5;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px !important;
}
#custom_card_shadow {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px !important;
}
</style>